import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ProcessSteps } from '../components/ProcessSteps';
import { Button } from '../components/Button';
export function HowItWorksPage() {
  return <main className="w-full" data-id="element-568">
      {/* Hero Section */}
      <section className="w-full bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-569">
        <div className="max-w-7xl mx-auto text-center" data-id="element-570">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-571">
            How It Works
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-572">
            Our streamlined process makes accessing your home equity simple,
            fast, and stress-free.
          </p>
        </div>
      </section>

      {/* Process Steps */}
      <ProcessSteps data-id="element-573" />

      {/* Detailed Explanation */}
      <section className="w-full bg-cream py-20 px-4" data-id="element-574">
        <div className="max-w-4xl mx-auto" data-id="element-575">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-12 text-center" data-id="element-576">
            What Makes Us Different
          </h2>

          <div className="space-y-8" data-id="element-577">
            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-578">
              <div className="flex items-start" data-id="element-579">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-580">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-581" />
                </div>
                <div data-id="element-582">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-583">
                    No Credit Checks Required
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-584">
                    Unlike traditional lenders, we don't base our decisions on
                    your credit score. Our lending is purely equity-based,
                    meaning your property's value and location are what matter
                    most. This makes our solutions accessible to homeowners
                    regardless of their credit history.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-585">
              <div className="flex items-start" data-id="element-586">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-587">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-588" />
                </div>
                <div data-id="element-589">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-590">
                    Fast Approval & Funding
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-591">
                    Our streamlined process means you can receive funds in as
                    little as 48 hours after approval. We understand that when
                    you need access to your equity, time is often of the
                    essence. Our efficient system ensures you get the funds you
                    need quickly.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-592">
              <div className="flex items-start" data-id="element-593">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-594">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-595" />
                </div>
                <div data-id="element-596">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-597">
                    Flexible Use of Funds
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-598">
                    There are no restrictions on how you use your home equity.
                    Whether it's for debt consolidation, home renovations,
                    investment opportunities, medical expenses, or any other
                    financial need, the choice is entirely yours.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-599">
              <div className="flex items-start" data-id="element-600">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-601">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-602" />
                </div>
                <div data-id="element-603">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-604">
                    Transparent Process
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-605">
                    We believe in complete transparency. From the initial
                    assessment to final funding, you'll know exactly what to
                    expect. No hidden fees, no surprises. Our team is available
                    to answer any questions throughout the entire process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="w-full relative overflow-hidden bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-606">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 60% 80% at 80% 20%, rgba(201,169,97,0.15) 0%, rgba(201,169,97,0.06) 40%, transparent 70%)'
      }} aria-hidden="true" data-id="element-607" />
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-608">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-609">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-610">
            Take the first step towards financial freedom. Get your free
            assessment in minutes.
          </p>
          <Button variant="primary" size="lg" icon href="/#form" data-id="element-611">
            Apply Now
          </Button>
        </div>
      </section>
    </main>;
}